import axios from 'axios';

const WORDPRESS_URL = 'https://aaronyang.me/wp-json/wp/v2';

export const getPosts = async () => {
  try {
    const response = await axios.get(`${WORDPRESS_URL}/posts`);
    return response.data;
  } catch (error) {
    console.error('Error fetching posts:', error);
    throw error;
  }
};

export const getPostById = async (id) => {
  try {
    const response = await axios.get(`${WORDPRESS_URL}/posts/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching post:', error);
    throw error;
  }
};

// New function to fetch pages
export const getPages = async () => {
  try {
    const response = await axios.get(`${WORDPRESS_URL}/pages`);
    return response.data;
  } catch (error) {
    console.error('Error fetching pages:', error);
    throw error;
  }
};

export const getPageById = async (id) => {
  try {
    const response = await axios.get(`${WORDPRESS_URL}/pages/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching page:', error);
    throw error;
  }
};
